/*eslint-disable*/
import React from 'react';
import { Steps } from 'rsuite';
import Check from '@mui/icons-material/Check';
import Stepper from '@/Components/Stepper';

const Heading = (props) => {
    const { mode = '', currentStep = '', currentStepName = '', title = '', stepper = [], isEditMode = false } = props;

    return (
        <div className='flex justify-start items-center gap-2 w-full p-4'>
            <div className='flex justify-start items-center gap-1'>
                <p className='font-semibold text-[16px]'>{mode} {title}: </p>
                <p className='m-0 text-[14px]'>
                    {currentStep ? 'Step ' + currentStep : ''} {stepper[currentStep - 1]?.title}
                </p>
            </div>

            <div className='flex-1 max-w-[650px] ml-16'>
                <Stepper steps={stepper} currentStep={currentStep} />
            </div>

        </div>
    );
};

export default Heading;
